// GET BOOKING REVIEW LIST
export const GET_BOOKING_REVIEW_LIST = 'GET_BOOKING_REVIEW_LIST';
export const GET_BOOKING_REVIEW_LIST_SUCCESS = 'GET_BOOKING_REVIEW_LIST_SUCCESS';
export const GET_BOOKING_REVIEW_LIST_FAILED = 'GET_BOOKING_REVIEW_LIST_FAILED';

// GET REVIEW OVERVIEW OF BOOKING REVIEW
export const GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW = 'GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW';
export const GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS = 'GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_SUCCESS';
export const GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED = 'GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW_FAILED';

// GET BOOKING REVIEW DETAIL
export const GET_BOOKING_REVIEW_DETAIL = 'GET_BOOKING_REVIEW_DETAIL';
export const GET_BOOKING_REVIEW_DETAIL_SUCCESS = 'GET_BOOKING_REVIEW_DETAIL_SUCCESS';
export const GET_BOOKING_REVIEW_DETAIL_FAILED = 'GET_BOOKING_REVIEW_DETAIL_FAILED';

// POST FEEDBACK BOOKING REVIEW
export const POST_FEEDBACK_BOOKING_REVIEW = 'POST_FEEDBACK_BOOKING_REVIEW';
export const POST_FEEDBACK_BOOKING_REVIEW_SUCCESS = 'POST_FEEDBACK_BOOKING_REVIEW_SUCCESS';
export const POST_FEEDBACK_BOOKING_REVIEW_FAILED = 'POST_FEEDBACK_BOOKING_REVIEW_FAILED';

// UPDATE BOOKING REVIEW (INTRANET)
export const UPDATE_BOOKING_REVIEW = 'UPDATE_BOOKING_REVIEW';
export const UPDATE_BOOKING_REVIEW_SUCCESS = 'UPDATE_BOOKING_REVIEW_SUCCESS';
export const UPDATE_BOOKING_REVIEW_FAILED = 'UPDATE_BOOKING_REVIEW_FAILED';

// DELETE BOOKING REVIEW (INTRANET)
export const DELETE_BOOKING_REVIEW = 'DELETE_BOOKING_REVIEW';
export const DELETE_BOOKING_REVIEW_SUCCESS = 'DELETE_BOOKING_REVIEW_SUCCESS';
export const DELETE_BOOKING_REVIEW_FAILED = 'DELETE_BOOKING_REVIEW_FAILED';

// UPDATE FEEDBACK BOOKING REVIEW
export const UPDATE_FEEDBACK_BOOKING_REVIEW = 'UPDATE_FEEDBACK_BOOKING_REVIEW';
export const UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS = 'UPDATE_FEEDBACK_BOOKING_REVIEW_SUCCESS';
export const UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED = 'UPDATE_FEEDBACK_BOOKING_REVIEW_FAILED';

// DELETE FEEDBACK BOOKING REVIEW
export const DELETE_FEEDBACK_BOOKING_REVIEW = 'DELETE_FEEDBACK_BOOKING_REVIEW';
export const DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS = 'DELETE_FEEDBACK_BOOKING_REVIEW_SUCCESS';
export const DELETE_FEEDBACK_BOOKING_REVIEW_FAILED = 'DELETE_FEEDBACK_BOOKING_REVIEW_FAILED';
